if (!customElements.get('collection-intro')) {
  customElements.define(
    'collection-intro',
    class CollectionIntro extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        const content = this.querySelector('[data-collapsible]');
        const toggle = this.querySelector('.collection-intro__toggle');
        if (!content || !toggle) return;

        this.dataset.initialized = 'true';
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          const nextExpanded = !expanded;

          content.classList.toggle('is-expanded', nextExpanded);
          toggle.setAttribute('aria-expanded', String(nextExpanded));
          toggle.textContent = nextExpanded
            ? toggle.dataset.expandedLabel
            : toggle.dataset.collapsedLabel;
          toggle.setAttribute(
            'aria-label',
            nextExpanded ? toggle.dataset.expandedAria : toggle.dataset.collapsedAria
          );
        });
      }
    }
  );
}
